var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDesign
    ? _c("div", { staticClass: "dsf_search_column" }, [
        _c("div", { staticClass: "item_inner" }, [
          _c(
            "div",
            { staticClass: "item-left-img" },
            [
              _c("dsf-image", {
                attrs: {
                  src: _vm._f("imgFormat")(""),
                  "error-src": _vm.dsf.config.setting_nc_image_default_img,
                },
              }),
              _c("span", { staticClass: "item-type" }, [_vm._v("课程")]),
              _c(
                "span",
                { staticClass: "item-time" },
                [
                  _c("dsf-icon", { attrs: { name: "shijian" } }),
                  _vm._v(" 00:20:21 "),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "item-right-desc" }, [
            _vm._m(0),
            _vm._m(1),
            _c("ul", { staticClass: "item-bottom-desc" }, [
              _c(
                "li",
                [
                  _c("dsf-icon", { attrs: { name: "shijian" } }),
                  _vm._v(" 5学时 "),
                ],
                1
              ),
              _c(
                "li",
                [
                  _c("dsf-icon", { attrs: { name: "dianzan_kuai" } }),
                  _vm._v(" 10 "),
                ],
                1
              ),
              _c(
                "li",
                [
                  _c("dsf-icon", { attrs: { name: "pinglun" } }),
                  _vm._v(" 15 "),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ])
    : _c("div", { staticClass: "dsf_search_column" }, [
        _c("div", { staticClass: "item_inner" }, [
          _c(
            "div",
            {
              staticClass: "item-left-img",
              on: {
                click: function ($event) {
                  return _vm.toDetail(_vm.data)
                },
              },
            },
            [
              _c("dsf-image", {
                attrs: {
                  src: _vm._f("imgFormat")(_vm.data["cover"]),
                  "error-src": _vm.dsf.config.setting_nc_image_default_img,
                },
              }),
              _c("span", { staticClass: "item-type" }, [
                _vm._v(_vm._s(_vm.data.typename)),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "item-right-desc" }, [
            _c("div", { staticClass: "title" }, [
              _c("span", { staticClass: "name ellipsis-2" }, [
                _vm._v(_vm._s(_vm.data.title)),
              ]),
            ]),
            _c("p", { staticClass: "item-name" }, [
              _c("span", [_vm._v(_vm._s(_vm.data.position || ""))]),
            ]),
          ]),
        ]),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", { staticClass: "name ellipsis-2" }, [_vm._v("我是一个标题")]),
      _c("span", { staticClass: "task" }, [_vm._v("任务")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item-teacher-name" }, [
      _c("span", [_vm._v("张三")]),
      _c("span", [_vm._v("项目经理")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }